export function isValidForm(formElement) {
	return $(formElement).valid();
}
